export default __webpack_public_path__ + "static/media/r2.d0e44484.jpg";